import React from "react";
import { Modal, Button, Card, Form, Row, Col } from "react-bootstrap";

const ServiceItemsModal = ({
  show,
  onHide,
  template,
  items,
  onUpdateItems,
  onSubmit,
}) => {
  const handleQuantityChange = (index, value) => {
    const newItems = [...items];
    newItems[index].quantity = parseFloat(value) || 0;
    onUpdateItems(newItems);
  };

  const handleQuantityShortcut = (index, shortcut) => {
    const newItems = [...items];
    newItems[index].quantity = shortcut;
    onUpdateItems(newItems);
  };

  const handleSubmit = () => {
    onSubmit(items);
  };

  if (!template) return null;

  return (
    <Modal show={show} onHide={onHide} size="xl" className="workshop-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title>Service: {template.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: "20px" }}>
          <h6>Items yang dibutuhkan:</h6>
        </div>
        <div style={{ display: "grid", gap: "12px" }}>
          {items.map((item, index) => (
            <Card key={index} style={{ border: "1px solid #e5e7eb" }}>
              <Card.Body style={{ padding: "16px" }}>
                <Row className="align-items-center">
                  <Col md={4}>
                    <strong>{item.name}</strong>
                  </Col>
                  <Col md={3}>
                    <Form.Control
                      type="number"
                      min="0"
                      step="0.1"
                      value={item.quantity}
                      onChange={(e) =>
                        handleQuantityChange(index, e.target.value)
                      }
                      placeholder="Jumlah"
                    />
                  </Col>
                  <Col md={2}>
                    <span style={{ color: "#6b7280" }}>{item.unit}</span>
                  </Col>
                  <Col md={3}>
                    <div
                      style={{
                        display: "flex",
                        gap: "4px",
                        flexWrap: "wrap",
                      }}
                    >
                      {[0.5, 1, 2, 4, 6].map((shortcut) => (
                        <Button
                          key={shortcut}
                          variant="outline-secondary"
                          size="sm"
                          onClick={() =>
                            handleQuantityShortcut(index, shortcut)
                          }
                          style={{ fontSize: "12px", padding: "2px 8px" }}
                        >
                          {shortcut}
                        </Button>
                      ))}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Batal
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Simpan Service
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ServiceItemsModal;
